import React from "react";

//Components
import NavbarPropDevsSection from "../../components/NavbarPropDevsSection/NavbarPropDevsSection";
import FooterPropDevs from "../../components/FooterPropDevs/FooterPropDevs";
import BodyAboutUs from "../../components/BodyAboutUs/BodyAboutUs";

const AboutUsScreen = () => {
  return (
    <>
      <NavbarPropDevsSection />
      <BodyAboutUs />
      <FooterPropDevs />
    </>
  );
};

export default AboutUsScreen;
